import { Menu } from "lucide-react";
import { useState } from "react";
import { SidebarNav } from "@/components/markyt/SidebarNav";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

export function MobileSidebar() {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        aria-label="Open navigation"
        className="grid size-9 place-items-center rounded-[9px] text-fg-2 hover:bg-bg-3 focus-visible:outline-2 focus-visible:outline-fg-link min-[880px]:hidden"
      >
        <Menu className="size-5" />
      </SheetTrigger>
      <SheetContent side="left" className="w-[248px] p-0">
        <SheetTitle className="sr-only">Navigation</SheetTitle>
        <SidebarNav onNavigate={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
}
